<script setup>
const nuxtApp = useNuxtApp()
import { useDisplay } from 'vuetify'

// mobile breakpoint
const { xs } = useDisplay()

const props = defineProps({
    id: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `${props.handle}-similar`,
    () => $fetch(`/api/product/query?id=${props.id}&what=similar`),
    {
        transform: (data) => {
            return {
                similarProducts: data.product.similar.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

// Log fetch error
watchEffect(() => {
    if (error.value) {
        throw createError({
            statusCode: 500,
            message: error.value,
            fatal: false,
        })
    }
})
</script>

<template>
    <v-row id="productssimilar" class="mx-n4 justify-center">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="10"><app-loader /></v-col>
        <v-col v-else cols="10">
            <v-row>
                <v-col cols="12" class="mt-16">
                    <app-section-header
                        :id="`similarproducts`"
                        :title="`Similar Products`"
                        :subtitle="`You may like these similar products`"
                    />
                </v-col>
                <v-col v-for="product in data.similarProducts" :key="product.id" cols="12" sm="6" lg="3">
                    <product-card-similar :product="product" />
                </v-col>
                <v-col cols="12" class="mb-16 pt-6 d-flex justify-center">
                    <v-theme-provider theme="sTLightTheme">
                        <app-button
                            :to="`/shop`"
                            :btn-text="`View All Products`"
                            :append-icon="`mdi-chevron-right`"
                            :size="xs ? undefined : `x-large`"
                            aria-label="View all Products"
                        />
                    </v-theme-provider>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
